<template>
  <div class="main">
    <!-- 头部 -->
    <div class="header">
      <div class="title">智码云通管理中心</div>
      <Navbar/>
    </div>
    <div class="content">
      <div class="menu_box">
        <!-- 用 el-tree 替代 el-menu，支持 accordion 手风琴模式 -->
        <el-tree
          :data="menuData"
          :props="treeProps"
          node-key="path"
          :default-expanded-keys="expandedKeys"
          :accordion="true"
          :highlight-current="true"
          :current-node-key="$route.path"
          @node-click="handleNodeClick"
          ref="treeRef"
        >
          <template #default="{ node, data }">
            <!-- 叶子节点：可点击跳转 -->
            <router-link 
              v-if="!data.children || data.children.length === 0"
              :to="data.path"
              class="tree-link"
              :class="{ 'is-active': $route.path === data.path }"
            >
              {{ data.name }}
            </router-link>
            <!-- 父节点：只展开，不跳转 -->
            <span v-else class="tree-label">{{ data.name }}</span>
          </template>
        </el-tree>
      </div>
      <div class="app-main">
        <transition name="fade-transform" mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import {Navbar} from "./components";
import {getMenu} from '@/utils/auth'


export default {
  components: {
    Navbar,
  },
  data() {
    return {
      totalTimeId: null,
      menuData: [],
      treeProps: {
        label: 'name',
        children: 'children'
      },
      expandedKeys: []
    }
  },
  destroyed() {
    clearInterval(this.totalTimeId)
  },
  created() {
    let menuInfo = this.$store.getters.menus
    const cookieMenu = getMenu()
    
    let menusList = []
    if (cookieMenu != null && typeof cookieMenu != "undefined") {
      menusList = JSON.parse(decodeURIComponent(cookieMenu))
    }
    
    menuInfo = menusList
    this.menuData = this.makeMenus(menuInfo, "")
    
    // 默认展开第一个
    if (this.menuData.length > 0 && this.menuData[0].children) {
      this.expandedKeys = [this.menuData[0].path]
    }
  },
  watch: {
    // 路由变化时同步高亮
    '$route.path': {
      immediate: true,
      handler(path) {
        // 找到当前路由的所有父级，展开它们
        // this.expandedKeys = this.findParentPaths(path)
        // 使用setCurrentKey让el-tree自动处理展开，配合accordion模式
        if (this.$refs.treeRef) {
          this.$refs.treeRef.setCurrentKey(path)
        }
      }
    }
  },
  methods: {
    handleNodeClick(data, node) {
      // 点击叶子节点时跳转（router-link 处理了，这里可以不做）
      if (!data.children || data.children.length === 0) {
        // 已经是 router-link 处理，这里防止重复
      }
    },
    
    findParentPaths(targetPath) {
      const findChain = (items, target, chain = []) => {
        for (let item of items) {
          const currentChain = [...chain, item.path]
          if (item.path === target) {
            return currentChain
          }
          if (item.children && item.children.length > 0) {
            const result = findChain(item.children, target, currentChain)
            if (result) return result
          }
        }
        return []
      }
      
      return findChain(this.menuData, targetPath)
    },
    
    makeMenus(arr, id) {
      let menus = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].pid == id) {
          let obj = {}
          obj.path = arr[i].path || arr[i].menuComponent || `/menu-${arr[i].id}`
          obj.name = arr[i].menuTableTitle || arr[i].menuName
          obj.id = arr[i].id
          obj.children = this.makeMenus(arr, arr[i].id)
          // 如果没有子节点，删除 children 属性（避免显示展开箭头）
          if (obj.children.length === 0) {
            delete obj.children
          }
          menus.push(obj)
        }
      }
      return menus
    },
  }
}
</script>

<style lang="less" scoped>
/* el-tree 样式适配 */
/deep/ .el-tree {
  background: transparent;
  border-right: none;
  
  .el-tree-node__content {
    height: 50px;
    line-height: 50px;
    padding: 0 !important;
    
    &:hover {
      background: #f1f8ff;
    }
  }
  
  .el-tree-node.is-current > .el-tree-node__content {
    background: #f1f8ff;
    color: #0078ff;
    font-weight: 600;
  }
  
  // 层级缩进
  .el-tree-node__children {
    .el-tree-node__content {
      padding-left: 20px !important;
    }
    .el-tree-node__children {
      .el-tree-node__content {
        padding-left: 40px !important;
      }
    }
  }
}

.tree-link,
.tree-label {
  display: block;
  width: 100%;
  height: 100%;
  line-height: 50px;
  color: #3B4F6A;
  font-weight: 600;
  text-decoration: none;
  padding-left: 20px;
  box-sizing: border-box;
}

.tree-link:hover,
.tree-label:hover {
  color: #0078ff;
}

.tree-link.is-active {
  color: #0078ff;
  background: #f1f8ff;
}

/* 原有样式保持不变 */
.app-main {
  width: 100%;
  height: calc(100vh - 100px);
  position: relative;
  overflow: hidden;
}

.main {
  width: 100vw;
  height: 100vh;
  min-width: 1200px;
  min-height: 600px;
  
  .header {
    width: 100%;
    height: 50px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 60px;
    border-bottom: 1px solid #e6e6e6;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    
    .title {
      font-size: 28px;
      width: 50%;
      color: #3B4F6A;
      font-family: 'PangMenZhengDao';
    }
  }
  
  .content {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }
  
  .menu_box {
    width: 300px;
    height: calc(100vh - 100px);
    border-right: 1px solid #e6e6e6;
    overflow-y: auto;
    background: #fff;
  }
}
</style>